import customer from './customer'
import addresses from './addresses'
import store from './store'
import payment from './payment'
import shipping from './shipping'
import extrasFiles from './extrasFiles'
import * as actions from './store/actions'
import * as utils from './utils'
import * as locales from './locales'
import * as config from './config'
import * as cartSummary from './cartSummary'

export { B3MethodsProps } from './b3Global.d'

export default {
  customer,
  store,
  actions,
  utils,
  locales,
  addresses,
  config,
  payment,
  shipping,
  extrasFiles,
  cartSummary,
}

export * from './components'
